import {
  type DashboardActions,
  FolderAccessRequestAction,
  InternalFolderActions as Internal,
} from '@store/reducers/dashboard/actions'
import { put, select } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { selectFolder } from '../../selectors/selectFolder'
import type { WorkspaceItem } from '../../types'
import { toggleId } from '../../utils'

export function* updateMemberAccess({
  payload: { workspaceId, folderId, id },
}: ReturnType<typeof DashboardActions.folders.updateMemberAccess>) {
  const folder: WorkspaceItem | null = yield select(
    selectFolder(workspaceId, folderId)
  )
  if (!folder) {
    return
  }

  sendGtmEvent(GtmTriggerName.DASHBOARD_FOLDER_VISIBILITY_SWITCH)

  const members = toggleId(id, folder.members)
  yield put(
    Internal.update({
      workspaceId,
      id: folder.id,
      data: {
        visibility: 'restricted',
        members,
      },
    })
  )

  yield put(
    FolderAccessRequestAction({
      workspaceId,
      id: folderId,
      visibility: 'restricted',
      members,
    })
  )
}
